export default "__VITE_ASSET__2TmSH4nx__"